export enum TABS {
  ORGANIZATION = 'organization',
  COALITION = 'coalition',
  CUSTOMERS = 'customers',
  REGIONAL = 'regionalSettings',
  BRAND = 'brand',
  ROLES = 'roles',
}
